import ProductService from '../../common/api/product.service.js';

export async function getProducts({ commit }) {
  const response = await ProductService.getProducts();

  if (response.status === 200) {
    const products = response.data;
    // eslint-disable-next-line no-nested-ternary
    products.sort((a, b) => ((a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0)));
    commit('updateProducts', response.data);
  }
}
